export default __webpack_public_path__ + "static/media/games-icon.3895a6d9.svg";